import React, { useEffect, useState } from 'react';
import {StyleSheet, View, Text, Dimensions} from 'react-native';
import { PAYMENT_URL } from '../network/Network';
import { getAccountId, getAccessToken, storeCartItems } from '../database/DataBase';

const HEIGHT = Dimensions.get('window').height
const WIDTH = Dimensions.get('window').width;
const isWeb = WIDTH > 992;

export default function CheckoutFooter(props) {
  
  const [accessToken, setAccessToken] = useState('');
  const [accountId, setAccountId] = useState('');
  const [itemIds, setItemIds] = useState([]);
  const [itemNames, setItemsNames] = useState([]);
  const [type, setType] = useState('addon');

  useEffect(() => {
    getAccessToken()
      .then((data) => {
        setAccessToken(data);
      })
      .catch((e) => {
        console.log('error', e);
      });
    getAccountId()
      .then((accountId) => {
        setAccountId(accountId)
      }).catch((e)=> {
        console.log('error', e);
      });
  }, []);
  
  useEffect(() => {
    if(props.isCartUpdated){
      let ids = [];
      let names = [];
      props.cartItems.forEach(element => {
        ids.push(element.id);
        names.push(element.pack_name);
        if(element.pack_type.toLowerCase() == 'base'){
          setType('renewal');
        }
      });
      setItemIds(ids);
      setItemsNames(names);
      storeCartItems(props.cartItems);
    }

    return () =>{ 
    }
  }, [props.cartItems, props.isCartUpdated]);

  return (
    props.show ? (
      <View style={styles.mainContainer}>
        <View style={styles.subContainer1}>
          <Text style={styles.text1}>{itemIds.length} Packs Selected</Text>
          <Text style={styles.text2} numberOfLines={2}>{itemNames.join(", ")}</Text>
          <Text style={styles.text3}>Network Capacity Fee and GST extra as applicable</Text>
        </View>
        <View style={styles.subContainer2}>
          {/* <Text style={{ color: 'white', fontSize: 24, marginBottom: 8 }}>Rs. 1000</Text> */}
          <View style={{ width: '100%' }}>
            <form action={PAYMENT_URL+'&pa='+accessToken} method="POST">
              <input type="hidden" name="account_ids" value={accountId} />
              {
                itemIds.map((obj) => {
                  return(
                    <input type="hidden" name="bouque_ids[]" value={obj} key={obj.toString()}/>
                  )
                })
              }
              <input type="hidden" name="type" value={type}/>
              <input type="hidden" name="rperiod_id" value={'2'}/>
              <input type="hidden" name="remark" value={'Purchase of packs: '+itemNames.join(", ")} />  
              <input type="submit" value="&#8377;  Make Payment" style={{ color: 'white', backgroundColor: 'red', width: '100%', borderRadius: 8, padding: isWeb ? 16 : 6 }}/>
            </form>
          </View>
        </View>
      </View>
    ) : (
      <></>
    )
  );
}

const styles = StyleSheet.create({
  mainContainer: {
    flexDirection: 'row', 
    width: '100%', 
    backgroundColor: '#000000', 
    position: 'fixed', 
    padding: 16, 
    left: 0, 
    right: 0, 
    bottom: 0 
  },
  subContainer1: { 
    flex: 1, 
    flexDirection: 'column', 
    // marginRight: 16 
  },
  subContainer2: { 
    flexDirection: 'column', 
    justifyContent: 'center', 
    alignItems: 'center', 
    textAlignVertical: 'center' 
  },
  text1: { 
    color: 'white', 
    fontSize: isWeb ? 24 : 20, 
    marginBottom: 8 
  },
  text2: { 
    color: 'white', 
    fontSize: isWeb ? 18 : 12, 
    marginBottom: 8 
  },
  text3: { 
    color: '#EFEFEF', 
    fontSize: isWeb ? 12 : 10
  }
});
